import Vue from 'vue'
import Router from 'vue-router'

// Containers
import BaseAdmin from '@/containers/BaseAdmin'
import Lti from '@/containers/Lti'

// Views - Pages
import Page400 from '@/views/pages/Page400'
import Page401 from '@/views/pages/Page401'
import Page403 from '@/views/pages/Page403'
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

// Sample route
import Sessions from '@/components/Lti/Sessions'
import Recordings from '@/components/Lti/Recordings'

import LoginAdmin from '@/LoginAdmin'
import LicencesAdmin from '@/components/Admin/LicencesAdmin'
import SessionsAdmin from '@/components/Admin/SessionsAdmin'
import UsersAdmin from '@/components/Admin/UsersAdmin'
import RecordingsReprocess from '@/components/Admin/RecordingsReprocess'
import VueJwtDecode from 'vue-jwt-decode'
import i18n from '@/i18n.js'

Vue.use(Router)
const token = $cookies.get('LTI_JWT')
if (token) {
  try {
    let jwtDecoded = VueJwtDecode.decode(token)
    i18n.locale = jwtDecoded.language
  } catch (e) {
    i18n.locale = 'es'
  }
} else {
  i18n.locale = 'es'
}

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: Lti,
      redirect: '/login',
      children: [
        {
          path: 'sesiones',
          name: 'Clases en directo',
          meta: { title: i18n.t('header.sessions') },
          component: Sessions
        },
        {
          path: 'grabaciones',
          name: 'Grabaciones',
          meta: { title: i18n.t('header.recordings') },
          component: Recordings
        }
      ]
    },
    {
      path: '/lti',
      component: Lti,
      redirect: '/sesiones'
    },
    {
      path: '/login',
      name: 'LoginAdmin',
      meta: { title: 'PROEDUCA Clases Virtuales' },
      component: LoginAdmin
    },
    {
      path: '/admin',
      name: 'BaseAdmin',
      component: BaseAdmin,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'licences',
          name: 'LicencesAdmin',
          meta: { title: 'Licencias LTI' },
          component: LicencesAdmin
        },
        {
          path: 'sessions',
          name: 'SessionsAdmin',
          meta: { title: 'Clases en directo' },
          component: SessionsAdmin
        },
        {
          path: 'users',
          name: 'UsersAdmin',
          meta: { title: 'Usuarios' },
          component: UsersAdmin
        },
        {
          path: 'recording-reprocess',
          name: 'RecordingsReprocess',
          meta: { title: 'Reprocesar Grabaciones' },
          component: RecordingsReprocess
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: { render (c) { return c('router-view') } },
      children: [
        {
          path: '400',
          name: 'Page400',
          component: Page400
        },
        {
          path: '401',
          name: 'Page401',
          component: Page401
        },
        {
          path: '403',
          name: 'Page403',
          component: Page403
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js